var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoBureaucracybutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_bureaucracybutton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_bureaucracybutton",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(13.000000, 9.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0803,4.2031 L32.7193,9.8411 L27.0803,9.8411 L27.0803,4.2031 Z M2.2433,2.7891 L25.0803,2.7891 L25.0803,5.8631 L5.1183,5.8631 L5.1183,7.8631 L25.0803,7.8631 L25.0803,11.8411 L34.1333,11.8411 L34.1333,26.6341 L36.1333,26.6341 L36.1333,10.4271 L26.4943,0.7891 L0.2433,0.7891 L0.2433,50.3521 L16.1203,50.3521 L16.1203,48.3521 L2.2433,48.3521 L2.2433,2.7891 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(5.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9153,20.752 C24.0823,20.752 20.1503,24.684 20.1503,29.517 L20.1503,40.615 L22.1503,40.615 L22.1503,29.517 C22.1503,25.787 25.1853,22.752 28.9153,22.752 C32.6453,22.752 35.6813,25.787 35.6813,29.517 L35.6813,40.615 L37.6813,40.615 L37.6813,29.517 C37.6813,24.684 33.7483,20.752 28.9153,20.752",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "13.725 30.686 17.906 30.686 17.906 28.686 13.725 28.686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "39.925 30.686 44.106 30.686 44.106 28.686 39.925 28.686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "40.6164 19.9478 37.2344 22.4058 38.4104 24.0238 41.7924 21.5658"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    points: "34.5608 15.5479 32.6588 14.9299 31.3668 18.9059 33.2688 19.5239"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "26.4641 18.9058 25.1721 14.9298 23.2701 15.5478 24.5621 19.5238"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    points: "17.2141 19.9478 16.0381 21.5658 19.4201 24.0238 20.5961 22.4058"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    points: "0.118 11.144 11.423 11.144 11.423 9.144 0.118 9.144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9153,33.6133 C28.0333,33.6133 27.3153,32.8953 27.3153,32.0133 C27.3153,31.1313 28.0333,30.4133 28.9153,30.4133 C29.7973,30.4133 30.5153,31.1313 30.5153,32.0133 C30.5153,32.8953 29.7973,33.6133 28.9153,33.6133 M28.9153,28.4133 C26.9313,28.4133 25.3153,30.0293 25.3153,32.0133 C25.3153,33.6493 26.4193,35.0173 27.9153,35.4543 L27.9153,40.6143 L29.9153,40.6143 L29.9153,35.4543 C31.4113,35.0173 32.5153,33.6493 32.5153,32.0133 C32.5153,30.0293 30.8993,28.4133 28.9153,28.4133",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    points: "0.118 7.144 26.196 7.144 26.196 5.144 0.118 5.144"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "0.118 2.715 4.233 2.715 4.233 0.715 0.118 0.715"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBureaucracybutton);
export default __webpack_public_path__ + "static/media/ico_bureaucracybutton.bd6360f886689fa01d4fce0f627aa15c.svg";
export { ForwardRef as ReactComponent };